import Vue from 'vue'
import Vuex from 'vuex'
import orderModule from './modules/orders'
import emailsTemplatesModule from './modules/emails_templates'
import emailsTemplatesCategoriesModule from './modules/email_templates_categories'
import allLeadsModule from './modules/all_leads.js'
import autocastModule from './modules/autocast.js'
import allSegmentsModule from './modules/all_segments.js'
import messageCampaignModule from './modules/message campaign.js'
import promocodesModule from './modules/promocodes.js'
import widgetsModule from './modules/widgets.js'
import userAlertsModule from './modules/user_alerts.js'
import reportEfficiencyLeadhitModule from './modules/report_efficiency_leadhit.js'
import reportAttributionStatisticModule from './modules/report_attribution_statistic.js'
import analyticsOffersModule from './modules/analytics_offers.js'
import siteFormsModule from './modules/site_forms.js'
import siteTariffsModule from './modules/site_tariffs.js'
import loyaltyModule from './modules/loyalty.js'
import recommendationsModule from '@/store/modules/recommendations'
import reportsModule from '@/store/modules/reports'
import trainingModule from '@/store/modules/training'
import analyticsModule from '@/store/modules/analytics'
import desktopModule from '@/store/modules/desktop'
import multileadsModule from './modules/multileads'
import siteCategoriesModule from './modules/site_categories'
import subscriptionsModule from './modules/subscriptions'

Vue.use(Vuex)

const state = {
  app_mode: process.env.NODE_ENV,
  force_redirect: process.env.FORCE_REDIRECT === 'true',
  side_menu_mode: true,
  user: null,
  color_theme:
    localStorage.getItem('lh-cp-color-theme') &&
    localStorage.getItem('lh-cp-color-theme') === 'true',
  language: localStorage.getItem('lh-cp-language') ? localStorage.getItem('lh-cp-language') : 'ru',
  backend_url: process.env.API_URL,
  tracker_backend_url: process.env.API_TRACKER_URL,
  widgetsystem_url: process.env.WIDGETSYSTEM_URL,
  tracker_url: process.env.TRACKER_URL,
  is_mobile_or_tablet: false,
  is_portrait_orientation: false,
  site_id: null,
  token: null,
  managers: null,
  offers: {
    items: null,
    pagination: null
  },
  regExp: {
    email: new RegExp(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\s*,\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/ // Вариант регулярки от Chat GPT для валидации строки с несколькими email (05.03.2025)
      // /^([0-9a-zA-Z-_\.]+@[0-9a-zA-Z-_\.]+\.[a-z]+)((\s*,\s*([0-9a-zA-Z-_\.]+@[0-9a-zA-Z-_\.]+\.[a-z]+))+|$)/
      // /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g
    ),
    tel: new RegExp(/^[\s()+-]*([0-9][\s()+-]*){10,11}$/),
    domain: new RegExp(/\/(?:[-\w]+\.)?([-\w]+)\.\w+(?:\.\w+)?\/?.*/i)
  },
  autocastEditorParams: null,
  editor_params: null,
  sites: null,
  current_site_info: null,
  notifications: [],
  site_status: null,
  site_codes: null,
  feed_info: false,
  alerts: [],
  traffic_sources_list: null,
  pageNavigation: {
    pageName: '',
    breadcrumbs: []
  },
  filled_forms_fields_list: {
    'add_1': '',
    'add_2': '',
    'add_3': '',
    'add_4': '',
    'add_5': '',
    'address': 'Адрес',
    'birthday': 'День рождения',
    'cart_sum': 'Сумма заказа',
    'city': 'Город',
    'company': 'Компания',
    'country': 'Страна',
    'discount_size': 'Размер скидки',
    'email': 'Почта',
    'fax': 'Факс',
    'index': 'Почтовый индекс',
    'last_name': 'Фамилия',
    'misc': 'Дополнительная информация',
    'name': 'Имя',
    'order_id': 'Номер заказа',
    'phone': 'Телефон',
    'position': 'Должность',
    'region': 'Регион',
    'sex': 'Пол',
    'sub_type': 'Тип подписки'
  }
}

const getters = {
  getFilledFormsFieldsList: (state) =>{
    return state.filled_forms_fields_list
  },
  getAllResponseHeaders: (state) => ({
    'Content-Type': 'application/json',
    'Accept-Language': state.language,
    'Auth-Token': state.token,
    'Leadhit-Site-Id': state.site_id
  }),
  userDoesNotHaveSites: (state) => {
    if (state.user && state.user.sites.length === 0) {
      return true
    }

    return false
  },
  pageName: (state) => {
    return state.pageNavigation.pageName
  },
  breadcrumbs: (state) => {
    return state.pageNavigation.breadcrumbs
  },
  force_redirect: (state) => {
    return state.force_redirect
  },
  sideMenuMode: (state) => {
    return state.side_menu_mode
  },
  is_mobile_or_tablet: (state) => {
    return state.is_mobile_or_tablet
  },
  is_portrait_orientation: (state) => {
    return state.is_portrait_orientation
  },
  getUserData: (state) => {
    return state.user
  },
  userPermissions: (state) => state.user.permissions,
  getSiteId: (state) => {
    return state.site_id
  },
  getSiteNameById: (state) => (site_id) => {
    let site_name = ''
    if (state.user && state.user.sites && state.user.sites.length > 0) {
      for (let i = 0; i < state.user.sites.length; i++) {
        if (state.user.sites[i].id === site_id) {
          site_name = state.user.sites[i].domain
        }
      }
    }
    return site_name
  },
  getColorTheme: (state) => {
    return state.color_theme
  },
  getLanguage: () => {
    return state.language
  },
  getBackendUrl: (state) => {
    return state.backend_url
  },
  getTrackerBackendUrl: (state) => {
    return state.tracker_backend_url
  },
  getWidgetsystemUrl: (state) => {
    return state.widgetsystem_url
  },
  getTrackerUrl: (state) => {
    return state.tracker_url
  },
  getToken: (state) => {
    return state.token
  },
  getManagers: (state) => {
    return state.managers
  },
  getAppMode: (state) => {
    return state.app_mode
  },
  getOffers: (state) => {
    return state.offers.items
  },
  getOffersPagination: (state) => {
    return state.offers.pagination
  },
  getOfferById: (state) => (id) => {
    return state.offers[id]
  },
  regExp: (state) => {
    return state.regExp
  },
  allSites: (state) => {
    return state.sites
  },
  notifications: (state) => {
    return state.notifications
  },
  getSiteStatus: (state) => {
    return state.site_status
  },
  getSiteCodes: (state) => {
    return state.site_codes
  },
  getFeedInfo: (state) => {
    return state.feed_info
  },
  alerts: (state) => {
    return state.alerts
  },
  traffic_sources_list: (state) => {
    return state.traffic_sources_list
  },
  current_site_info: (state) => {
    return state.current_site_info
  }
}

const actions = {
  GET_TASK_RESULT: ({ dispatch, rootGetters }, payload) => {
    let params = {
      result_id: payload.result_id,
      result_type: payload.result_type
    }

    return Vue.http
      .get(`${rootGetters.getBackendUrl}/tasks/result`, {
        params,
        headers: rootGetters.getAllResponseHeaders
      })
      .then((response) => {
        if (response.status === 200 && response.body.ready === false) {
          return dispatch('GET_TASK_RESULT', payload)
        } else if (response.body.ready === true) {
          return response
        } else {
          console.log('Error response', response)
        }
      })
  }
}

const mutations = {
  setPageNavigation(state, nav) {
    state.pageNavigation = nav
  },
  setUserData(state, data) {
    state.user = data
  },
  setIsMobileOrTablet(state, data) {
    state.is_mobile_or_tablet = data
  },
  setIsPortraitOrientation(state, data) {
    state.is_portrait_orientation = data
  },
  setSiteId(state, site_id) {
    state.site_id = site_id
  },
  toggleSideMenuMode(state, mode) {
    state.side_menu_mode = mode
  },
  toggleColorTheme(state, value) {
    state.color_theme = value
  },
  toggleLanguage(state, value) {
    state.language = value
  },
  setToken(state, token) {
    state.token = token
  },
  setManagers(state, managers) {
    state.managers = managers
  },
  setOffers(state, data) {
    state.offers.items = data
  },
  setOffersPagination(state, data) {
    state.offers.pagination = data
  },
  setOffer(state, data) {
    if (!state.offers.hasOwnProperty(data.id)) {
      state.offers[data.id] = data
    }
  },
  setAllSites(state, data) {
    state.sites = data
  },
  addNotification(state, notification) {
    state.notifications.push(notification)
  },
  setSiteStatus(state, data) {
    state.site_status = data
  },
  setSiteCodes(state, data) {
    state.site_codes = data
  },
  setFeedInfo(state, data) {
    state.feed_info = data
  },
  removeNotificationByName(state, notification_name) {
    state.notifications = state.notifications.filter(function (notification) {
      if (notification.name && notification.name === notification_name) {
        return false
      } else {
        return true
      }
    })
  },
  addAlert(state, alert) {
    state.alerts.push(alert)
  },
  resetAlerts(state) {
    state.alerts = []
  },
  setTrafficSourcesList(state, traffic_sources_list) {
    state.traffic_sources_list = traffic_sources_list
  },
  setCurrentSiteInfo(state, data) {
    state.current_site_info = data
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    autocast: autocastModule,
    orders: orderModule,
    emails_templates: emailsTemplatesModule,
    email_templates_categories: emailsTemplatesCategoriesModule,
    all_leads: allLeadsModule,
    all_segments: allSegmentsModule,
    message_campaign: messageCampaignModule,
    promocodes: promocodesModule,
    widgets: widgetsModule,
    user_alerts: userAlertsModule,
    report_efficiency_leadhit: reportEfficiencyLeadhitModule,
    report_attribution_statistic: reportAttributionStatisticModule,
    analytics_offers: analyticsOffersModule,
    site_forms: siteFormsModule,
    site_tariffs: siteTariffsModule,
    loyalty: loyaltyModule,
    recommendations: recommendationsModule,
    reports: reportsModule,
    training: trainingModule,
    analytics: analyticsModule,
    desktop: desktopModule,
    multileads: multileadsModule,
    site_categories: siteCategoriesModule,
    subscriptions: subscriptionsModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js